import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2, HelpCircle } from "lucide-react";
import { sanitizeRich } from "@/lib/sanitize";
import { highlightHtml } from "@/lib/help";

const Html = ({ html, term, testid }) => (
  <div className="help-prose" data-testid={testid} dangerouslySetInnerHTML={{ __html: highlightHtml(sanitizeRich(html), term) }}/>
);

export default function HelpTopicView({ topic, term, canEdit, onEdit, onDelete }) {
  return (
    <article className="bg-white border border-slate-300 p-6 md:p-10 animate-in fade-in duration-300" data-testid={`help-topic-${topic.slug}`}>
      <div className="flex items-start gap-4 mb-6">
        <div className="mr-auto">
          <p className="font-overline text-[10px] text-[#E11D48] mb-1">{topic.section}</p>
          <h2 className="font-heading text-3xl md:text-4xl tracking-tight" data-testid="help-topic-title">{topic.title}</h2>
        </div>
        {canEdit && (
          <div className="flex gap-2 shrink-0">
            <Button size="sm" variant="outline" className="rounded-sm" onClick={onEdit} data-testid="help-edit-topic"><Pencil className="w-3.5 h-3.5 mr-1"/>Edit</Button>
            <Button size="sm" variant="outline" className="rounded-sm text-red-600 border-red-300" onClick={onDelete} data-testid="help-delete-topic"><Trash2 className="w-3.5 h-3.5"/></Button>
          </div>
        )}
      </div>
      {topic.content ? <Html html={topic.content} term={term} testid="help-topic-content"/> : (
        <p className="text-sm text-slate-400 italic">No content yet.</p>
      )}
      {(topic.faqs || []).length > 0 && (
        <section className="mt-10" data-testid="help-topic-faqs">
          <h3 className="font-heading text-xl flex items-center gap-2 mb-2"><HelpCircle className="w-5 h-5 text-[#E11D48]"/>FAQs</h3>
          <Accordion type="multiple" className="border-t">
            {topic.faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`help-faq-${i}`}>
                <AccordionTrigger className="text-left font-medium">{f.q}</AccordionTrigger>
                <AccordionContent><Html html={f.a} term={term}/></AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      )}
      {topic.updated_at && <p className="mt-8 text-[11px] text-slate-400">Last updated {new Date(topic.updated_at).toLocaleDateString()}</p>}
    </article>
  );
}
